import { Constants } from "@constants";
import { createSlice } from "@reduxjs/toolkit";
import apiService from "@utils/apiService";
import { verifyApiResponse } from "@utils/apiResponseHelper";

const initialState = {
  loading: false,
  error: false,
  data: [],
  saveLoading: false,
  saveError: false,
  saveSuccess: false,
  resetDefaultLoading: false,
  resetDefaultError: false,
  resetDefaultSuccess: false,
};

export const customizeWeightsSlice = createSlice({
  name: "customizeWeights",
  initialState,
  reducers: {
    customizeWeightsStart: (state) => ({
      ...state,
      loading: true,
      error: false,
    }),
    customizeWeightsSuccess: (state, action) => ({
      ...state,
      loading: false,
      error: false,
      data: action.payload,
    }),
    customizeWeightsFailure: (state) => ({
      ...state,
      loading: false,
      error: true,
    }),
    saveCustomizeWeightsStart: (state) => ({
      ...state,
      saveLoading: true,
      saveError: false,
      saveSuccess: false,
    }),
    saveCustomizeWeightsSuccess: (state) => ({
      ...state,
      saveLoading: false,
      saveError: false,
      saveSuccess: true,
    }),
    saveCustomizeWeightsFailure: (state) => ({
      ...state,
      saveLoading: false,
      saveSuccess: false,
      saveError: true,
    }),
    resetDefaultCustomizeWeightsStart: (state) => ({
      ...state,
      resetDefaultLoading: true,
      resetDefaultError: false,
      resetDefaultSuccess: false,
    }),
    resetDefaultCustomizeWeightsSuccess: (state) => ({
      ...state,
      resetDefaultLoading: false,
      resetDefaultError: false,
      resetDefaultSuccess: true,
    }),
    resetDefaultCustomizeWeightsFailure: (state) => ({
      ...state,
      resetDefaultLoading: false,
      resetDefaultSuccess: false,
      resetDefaultError: true,
    }),
    resetCustomizeWeights: () => ({
      ...initialState,
    }),
  },
});

export const getCustomizeWeights = (scorecardId) => (dispatch) => {
  dispatch(customizeWeightsStart());
  apiService.get(
    `${Constants.API.CUSTOMIZE_WEIGHTS}${Constants.API.SCORE_CARD_TERM}${scorecardId}`
  ).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      let ifDataExists = Object.keys(data?.data);
      if (ifDataExists?.length > 0) {
        dispatch(customizeWeightsSuccess(data?.data));
      } else {
        dispatch(customizeWeightsFailure());
      }
    } else {
      dispatch(customizeWeightsFailure());
    }
  }).catch(() => {
    dispatch(customizeWeightsFailure());
  })
};

export const saveCustomizeWeights = (payload, scorecardId) => (dispatch) => {
  dispatch(saveCustomizeWeightsStart());
  apiService.post(
    `${Constants.API.CUSTOMIZE_WEIGHTS}${Constants.API.SCORE_CARD_TERM}${scorecardId}`
  , payload).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      dispatch(saveCustomizeWeightsSuccess());
    } else {
      dispatch(saveCustomizeWeightsFailure());
    }
  }).catch(() => {
      dispatch(saveCustomizeWeightsFailure());
  })
}

export const resetDefaultCustomizeWeights = (scorecardId) => (dispatch) => {
  dispatch(resetDefaultCustomizeWeightsStart());
  apiService.post(
    `${Constants.API.CUSTOMIZE_WEIGHTS}${Constants.API.RESET_WEIGHTS}${scorecardId}
  `).then((response) => {
    let data = verifyApiResponse(response);
    if (data?.systemMessage?.success) {
      dispatch(resetDefaultCustomizeWeightsSuccess());
    } else {
      dispatch(resetDefaultCustomizeWeightsFailure());
    }
  }).catch(() => {
      dispatch(resetDefaultCustomizeWeightsFailure());
  })
}

export const {
  customizeWeightsStart,
  customizeWeightsSuccess,
  customizeWeightsFailure,
  saveCustomizeWeightsStart,
  saveCustomizeWeightsSuccess,
  saveCustomizeWeightsFailure,
  resetCustomizeWeights,
  resetDefaultCustomizeWeightsStart,
  resetDefaultCustomizeWeightsSuccess,
  resetDefaultCustomizeWeightsFailure,
} = customizeWeightsSlice.actions;

export default customizeWeightsSlice.reducer;
